import PageLayout from "examples/LayoutContainers/PageLayout";
import { useEffect, useState } from "react";
import { useAgencyInfo } from "context/agency";
import Loader from "examples/Loader";
import Pricing from "./Pricing";
import Tabs from "../components/Tabs";
import CreateModal from "./components/CreateModal/index";
import { useAppServices } from "hook/services";
import SettingINFO from "./SettingINFO";
import SoftTypography from "components/SoftTypography";
import breakpoints from "assets/theme/base/breakpoints";

function Saas() {
  const { values } = breakpoints;
  const [Load, setLoad] = useState(0);
  const AppService = useAppServices();
  const [products, setproducts] = useState([]);
  const [potentialproducts, setpotentialproducts] = useState([]);
  const [agency] = useAgencyInfo();
  const [open, setOpen] = useState(false);
  const [prices, setPrices] = useState([]);

  const onLoad = () => {
    getProducts();
    getPotentialProducts();
    setLoad(false);
  };

  const getProducts = async () => {
    const { response } = await AppService.saas.agencysaas({
      query: `agency_id=${agency._id}`,
      toaster: false,
    });
    if (response) {
      setproducts(response?.data);
    } else {
    }
  };
  const getPotentialProducts = async () => {
    const { response } = await AppService.saas.potentialproducts({
      query: `agency_id=${agency._id}`,
      toaster: false,
    });
    if (response) {
      setpotentialproducts(response);
    } else {
    }
  };
  useEffect(() => {
    onLoad();
  }, []);

  return (
    <>
      {Load ? (
        <Loader />
      ) : (
        <PageLayout>
          <div style={{ width: "100%", position: "relative" }} className="d-flex justify-content-between">
            <SoftTypography
              variant={window.innerWidth < values.sm ? "h3" : "h2"}
              textTransform="capitalize"
              fontWeight="600"
            >
              Plans
            </SoftTypography>
            <div style={{
              width: "50%",
              marginTop: "105px",
              textAlign: "right",
              textAlign: "right",
              position: "absolute",
              right: 13,
            }}>
              <div className="d-flex justify-content-end">
                <button className="btn-new-design-black" onClick={() => setOpen(true)}>
                  Add Plan
                </button>
                {open && (
                  <CreateModal
                    open={open}
                    onClose={() => setOpen(false)}
                    prices={prices}
                    handleRefresh={onLoad}
                    data={products}
                  />
                )}
              </div>
            </div>
          </div>
          <Tabs
            tabsData={[
              {
                label: "Price and planing",
                content: (
                  <Pricing
                    data={products}
                    potentialproducts={potentialproducts}
                    handleRefresh={onLoad}
                  />
                ),
              },
              { label: 'Advanced Settings', content: <SettingINFO /> },
            ]}
          />
        </PageLayout>
      )}
    </>
  );
}

export default Saas;
